module.exports = __webpack_public_path__ + "8c5f291f7f7bdee731ac2a564c7d8e07.MP3";